'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _de_DE = require('../locale/de_DE');

var _de_DE2 = _interopRequireDefault(_de_DE);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _de_DE2['default'];